export default __webpack_public_path__ + "static/media/stipe.fa7a9f78.jpg";